import uniqueId from 'lodash/uniqueId';

import { CheckType, ResultType } from './PreviewYesNoSplitModal.constants';
import { UserToCheck } from './PreviewYesNoSplitModal.types';

export const stubUser = (lookupType: number): UserToCheck => ({
  checkType: lookupType === 0 ? CheckType.Email : CheckType.UserId,
  value: '',
  result: ResultType.Unknown,
  loading: false,
  error: false,
  id: uniqueId(),
});
